import React, { useEffect, useState } from "react";
import ProductPageLayout from "src/components/common/Layout/ProductPageLayout";
import dynamic from "next/dynamic";
import SpecificationAccordionList from "src/components/Specification/SpecificationAccordion/SpecificationAccordionList";
import CatalogProductSidebar from "src/components/ProductPage/components/CatalogProductSidebar/CatalogProductSidebar";
import {
  EnumMetrikActions,
  sendCustomYandexMetrik,
} from "src/config/analytics/sendCustomYandexMetrik";
import HeaderNavigation from "src/components/common/HeaderNavigation/HeaderNavigation";
import AnotherLinksList from "src/components/common/AnotherLinksList/AnotherLinksList";
import PharmaciesInYourCity from "src/components/common/PharmaciesInYourCity/PharmaciesInYourCity";
import { NewCatalogProductSchema } from "src/models/newProduct/getNewProduct";
import ProductBottomInfo from "src/components/NewProductPage/components/ProductBottomInfo/ProductBottomInfo";
import MainProductInfo from "src/components/NewProductPage/components/MainProductInfo/MainProductInfo";
import AnalogsSection from "src/components/NewProductPage/components/AnalogsSection/AnalogsSection";
import { useGetProductPrice } from "src/components/NewProductPage/components/hooks/useGetProductPrice";
import { useGetMainProductInfo } from "src/components/NewProductPage/components/hooks/useGetMainProductInfo";
import { useGetAnalogs } from "src/components/NewProductPage/components/hooks/useGetAnalogs";
import AnalogListSkeleton from "src/components/NewProductPage/components/AnalogsSection/components/AnalogListSkeleton";

const ReservationProduct = dynamic(
  import("src/components/ReservationProduct/ReservationProduct"),
  { ssr: false }
);

interface ProductPageProps {
  productData: NewCatalogProductSchema;
}

const NewProductPage: React.FC<ProductPageProps> = ({ productData }) => {
  const [isOpenReservationModal, setOpenReservationModal] = useState(false);

  useEffect(() => {
    sendCustomYandexMetrik(EnumMetrikActions.goToTheProductPage);
  }, []);

  const { isLoadingPrice, productPriceData } = useGetProductPrice();
  const { isLoadingProductInfo, mainProductInfo } = useGetMainProductInfo();
  const { analogs, isLoadingAnalogs } = useGetAnalogs();

  return (
    <ProductPageLayout
      SideBar={
        <CatalogProductSidebar
          name={productData.main_section.name}
          imgSrc={productData.main_section.image}
          nonPrescriptionDrug={productData.main_section.nonPrescriptionDrug}
          catalogBrandSlug={productData.main_section.catalog_brand_slug}
          picMatch={productData.main_section.pic_match}
        />
      }
    >
      <HeaderNavigation />
      <MainProductInfo
        setOpenReservationModal={setOpenReservationModal}
        productData={productData}
        isLoadingPrice={isLoadingPrice}
        productPrice={productPriceData}
        mainProductInfo={mainProductInfo}
        isLoadingProductInfo={isLoadingProductInfo}
      />
      {isLoadingAnalogs ? (
        <AnalogListSkeleton />
      ) : (
        <AnalogsSection analogs={analogs} isLoadingAnalogs={isLoadingAnalogs} />
      )}
      <SpecificationAccordionList
        title="Инструкция"
        instructionData={productData.instruction_section}
        descMatch={productData.main_section.desc_match}
      />
      {isOpenReservationModal && (
        <ReservationProduct
          isOpen={isOpenReservationModal}
          closeModal={() => {
            sendCustomYandexMetrik(EnumMetrikActions.pressBtnCloseInMap);
            setOpenReservationModal(false);
          }}
          productSlug={productData.main_section.slug}
          imgSource={productData.main_section.image}
        />
      )}
      <AnotherLinksList
        title={productData.mnn_links_block.name}
        data={productData.mnn_links_block.items}
        image={productData?.mnn_links_block.icon}
        sx={{ mb: 1 }}
      />
      <PharmaciesInYourCity
        title={productData.pharmacy_companies.name}
        data={productData.pharmacy_companies.items}
        image={productData.pharmacy_companies.icon}
        sx={{ mb: 1 }}
      />
      <AnotherLinksList
        sx={{ mb: 1 }}
        title={productData.product_links_block.name}
        data={productData.product_links_block.items}
        image={productData?.product_links_block.icon}
      />
      <ProductBottomInfo
        sx={{ mb: 1 }}
        title={productData.info_section.name}
        data={productData.info_section}
        image={productData.info_section.icon}
      />
    </ProductPageLayout>
  );
};

export default NewProductPage;
